export default __webpack_public_path__ + "static/media/Q4-Investor-Presentation.07d8678c.pdf";